export interface SubscriptionPreset {
	id: string;
	nameKey: string;
	runs: number;
	intervalMinutes: number;
}

export const SUBSCRIPTION_PRESETS: SubscriptionPreset[] = [
	{ id: 'daily-7', nameKey: 'subscriptions.presets.daily7', runs: 7, intervalMinutes: 1440 },
	{ id: 'daily-15', nameKey: 'subscriptions.presets.daily15', runs: 15, intervalMinutes: 1440 },
	{ id: 'daily-30', nameKey: 'subscriptions.presets.daily30', runs: 30, intervalMinutes: 1440 },
	{ id: 'custom', nameKey: 'subscriptions.presets.custom', runs: 0, intervalMinutes: 0 },
];
